import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { usePostFormInit } from '../../hooks/usePostFormInit';
import { cleanupStorage, submitAddBlog, submitEditBlog, uploadImage } from '../../reducers/modules/add_blog/add_blog';
import { fetchUser } from '../../reducers/modules/current_user';
import * as Analytics from '../../../app/helpers/analytics_helper';

const CRUMBS = [{ path: '/magazine' }, { path: '/blogs' }, { path: '/add-blog' }];

const SEO = {
  seoTitle: 'Новая запись в блоге',
  seoUrl: 'https://cian.ru/add-blogs/',
  seoDescription: 'Циан - авторские колонки, блоги специалистов рынка недвижимости, блоги риелторов. Обсуждения, комментарии.',
  seoKeywords: 'авторские колонки, блоги специалистов рынка недвижимости, блоги риелторов',
};

export const useAddBlogPage = () => {
  const dispatch = useAppDispatch();
  const addBlog = useAppSelector(state => state.addBlog);

  const { user, regions, tags, editingItem, deviceType } = usePostFormInit({
    crumbs: CRUMBS,
    seo: SEO,
    postCardEndpoint: '/v1/get-blog',
    formState: addBlog,
    cleanupStorage,
    redirectPathBuilder: (slug, id) => `/blogs-${slug}-${id}`,
    fetchUserAfterSubmit: true,
  });

  const onSubmitAdd = (
    content: string,
    status: string,
    isSubscribedToComments: boolean,
    category: string,
    regionsId: number[],
    tags: string,
    title: string,
    imageData: string,
    userEmail: string,
    userName: string,
  ) => {
    if (status === 'draft') {
      Analytics.addPost('save_post');
    } else {
      Analytics.addPost('add_post');
    }

    if (isSubscribedToComments) {
      Analytics.subscribeComments('new_comments', 'Magazine_subscription');
    }

    dispatch(submitAddBlog(content, status, isSubscribedToComments, category, regionsId, tags, title, imageData, userEmail, userName));
    dispatch(fetchUser());
  };

  const onSubmitEdit = (
    id: number,
    content: string,
    status: string,
    isSubscribedToComments: boolean,
    category: string,
    regionsId: number[],
    tags: string,
    title: string,
    imageData: string,
    imageClear: boolean,
  ) => {
    dispatch(submitEditBlog(id, content, status, isSubscribedToComments, category, regionsId, tags, title, imageData, imageClear));
  };

  const onUploadImage = (img: string) => dispatch(uploadImage(img));

  return {
    user,
    regions,
    tags,
    addBlog,
    editingItem,
    deviceType,
    onSubmitAdd,
    onSubmitEdit,
    onUploadImage,
  };
};
